import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { MultilingualCurrencyPipe } from '../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe';
import { NumericMaskDirective } from '../../../shared/numeric/numeric-mask.directive';
import { SolEstimateTableTaxRate, SolEstimateTableTaxRateRow } from '../../../models/sol-estimate-table/SolEstimateTableTaxRate';
import { DecimalPrecisionPipe } from "../../../pipes/decimal-precision-pipe/decimal-precision.pipe";
import { SolEstimateTableCommonFunctionsService } from '../../../services/sol-estimate-table-common-functions/sol-estimate-table-common-functions.service';

@Component({
  selector: 'app-sol-estimate-table-tax-material-rate',
  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NumericMaskDirective,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
  ],
  templateUrl: './sol-estimate-table-tax-material-rate.component.html',
  styleUrl: './sol-estimate-table-tax-material-rate.component.scss'
})
export class SolEstimateTableTaxMaterialRateComponent {

  @Input() taxMaterialRateFormGroup: FormGroup<SolEstimateTableTaxRate>;
  @Input() isCollaborativeNotEdit: boolean = false;

  isTaxMaterialRateExpanded: boolean = false;

  constructor(public readonly solEstimateTableCommonFunctionsService: SolEstimateTableCommonFunctionsService) { }


  get headerRow() {
    return this.taxMaterialRateFormGroup.controls.headerRow.controls;
  }

  get taxMaterialRateFormArray(): FormArray<FormGroup<SolEstimateTableTaxRateRow>> {
    return this.taxMaterialRateFormGroup.controls.taxRateRows;
  }

  trackByTaxMaterialRateIndex(index: number, item: FormGroup<SolEstimateTableTaxRateRow>): string {
    return item.controls.name.value;
  }
}
